var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcnClose = function SvgIcnClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1F",
    fillRule: "evenodd",
    d: "m9.409 7.998 6.295-6.285a1.003 1.003 0 0 0-1.419-1.42L8 6.59 1.715.294a1.003 1.003 0 0 0-1.42 1.419l6.296 6.285-6.295 6.286a1 1 0 0 0 0 1.419 1 1 0 0 0 1.419 0L8 9.407l6.285 6.296a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z"
  })));
};
export default SvgIcnClose;